'use client';

import { c as _c } from "react/compiler-runtime";
import { Arrow, Button } from '@sprd/sprd-component-kit/v2';
import { useTranslations } from 'next-intl';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { usePageChrome } from '@/hooks/usePageChrome';
import { useScrolledPastViewport } from '@/hooks/useScrolledPastViewport';
import { MAIN_CONTENT_ID } from '@/components/Page/mainContentId';
const ScrollToTopButton = () => {
  const $ = _c(8);
  const t = useTranslations("general");
  const isPastViewport = useScrolledPastViewport();
  const prefersReducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
  if (!isPastViewport) {
    return null;
  }
  let t0;
  if ($[0] !== prefersReducedMotion) {
    t0 = () => {
      window.scrollTo({
        top: 0,
        behavior: prefersReducedMotion ? "instant" : "smooth"
      });
      document.getElementById(MAIN_CONTENT_ID)?.focus({
        preventScroll: true
      });
    };
    $[0] = prefersReducedMotion;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const scrollToTop = t0;
  let t1;
  if ($[2] !== t) {
    t1 = t("a11y.backToTop");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Arrow className="m-0.5 size-6 -rotate-90" aria-hidden={true} fill="#FFFFFF" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== scrollToTop || $[6] !== t1) {
    t3 = <Button className="shadow-md" isRound={true} variant="primary" onClick={scrollToTop} aria-label={t1}>{t2}</Button>;
    $[5] = scrollToTop;
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};

/**
 * Scrolls a list page back up to its filters and sorting.
 *
 * The page shell is shared, so this mounts on every page. The scroll and resize
 * listeners sit in `ScrollToTopButton` instead, which only mounts where the
 * button can actually show.
 */
export const BackToTopButton = () => {
  const $ = _c(2);
  const {
    showBackToTop
  } = usePageChrome();
  let t0;
  if ($[0] !== showBackToTop) {
    t0 = showBackToTop ? <ScrollToTopButton /> : null;
    $[0] = showBackToTop;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};